<div class="gamification-container">
    <!-- Estado de carga -->
    <div *ngIf="!loaded" class="loading-state">
        <div class="loading-spinner"></div>
        <p class="loading-text">{{ "words.loading" | translate }}</p>
    </div>

    <!-- Contenido principal -->
    <div *ngIf="loaded" class="gamification-content">
        <!-- Cabecera -->
        <header
            class="flex justify-between items-center gap-6 mb-6 p-6 bg-white rounded-lg border border-gray-200 shadow-sm"
        >
            <div class="flex flex-col gap-1">
                <h1 class="text-lg font-semibold text-gray-900">
                    {{ gamificationData.title | translate }}
                </h1>
                <p class="text-sm text-gray-600 mt-1">
                    {{ gamificationData.description | translate }}
                </p>
            </div>

            <div class="flex items-center gap-2">
                <label class="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        [(ngModel)]="gamificationData.enabled"
                        class="sr-only peer"
                    />
                    <div
                        class="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-500"
                    ></div>
                    <span
                        class="ml-2 text-sm font-medium text-gray-700 min-w-[50px]"
                    >
                        {{
                            gamificationData.enabled
                                ? ("words.active" | translate)
                                : ("words.inactive" | translate)
                        }}
                    </span>
                </label>
            </div>
        </header>

        <!-- Sección de puntos -->
        <div class="sections-points px-4">
            <div class="flex flex-col gap-1 px-4 mb-4">
                <h2 class="text-lg font-semibold text-gray-700">
                    {{ pointsData.title | translate }}
                </h2>
                <p class="text-gray-500 text-sm">
                    {{ pointsData.description | translate }}
                </p>
            </div>
            <section class="points-section compact">
                <div class="compact-grid">
                    <div
                        *ngFor="
                            let section of pointsData.sections;
                            trackBy: trackBySection
                        "
                        class="compact-card hover:shadow-lg transition-shadow"
                    >
                        <h3 class="compact-card-title mb-2 line-clamp-2">
                            {{ section.title | translate }}
                        </h3>

                        <div
                            *ngFor="
                                let setting of section.settings;
                                let i = index
                            "
                            class="compact-setting"
                        >
                            <label
                                *ngIf="setting.label"
                                class="relative compact-label"
                            >
                                {{ setting.label | translate }}
                            </label>

                            <div class="compact-control">
                                <input
                                    *ngIf="setting.type === 'number'"
                                    type="number"
                                    [(ngModel)]="setting.value"
                                    [step]="setting.step || 1"
                                    [min]="setting.min || 0"
                                    [required]="setting.required"
                                    class="compact-input"
                                />

                                <div
                                    *ngIf="setting.type === 'checkbox'"
                                    class="compact-toggle"
                                >
                                    <label class="relative toggle-switch">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="setting.value"
                                            id="checkbox-{{ i }}"
                                        />
                                        <span class="slider"></span>
                                    </label>
                                    <span class="toggle-status">
                                        {{
                                            setting.value
                                                ? ("words.active" | translate)
                                                : ("words.inactive" | translate)
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="badge-pack-selector">
            <label>Selecciona un paquete de insignias:</label>

            <div class="flex items-center justify-center badge-pack-row">
                <div *ngFor="let pack of badgePacks" class="badge-pack-option">
                    <input
                        type="radio"
                        [id]="'pack-' + pack.number"
                        name="badgePack"
                        [value]="pack.number"
                        [(ngModel)]="selectedPackPath"
                        (change)="onPackChange()"
                        hidden
                    />

                    <label [for]="'pack-' + pack.number" class="badge-label">
                        <img
                            [src]="
                                'assets/badges/' + pack.path + '/preview.png'
                            "
                            [alt]="pack.title"
                            class="badge-image"
                            [class.selected]="selectedPackPath === pack.number"
                        />
                        <div class="badge-title">
                            {{ pack.title | translate }}
                        </div>
                    </label>
                </div>
            </div>
        </div>

        <!-- Sección de niveles -->
        <section class="levels-section mt-8 mb-4 px-4">
            <div class="flex flex-col gap-1 px-4 mb-8">
                <h2 class="text-lg font-semibold text-gray-700">
                    {{ levelsData.title | translate }}
                </h2>
            </div>
            <div
                class="table-container overflow-x-auto bg-white border border-gray-50 shadow-md mx-4"
            >
                <table class="levels-table min-w-[600px] w-full">
                    <thead
                        class="box-experience__title sticky top-0 bg-white"
                        style="z-index: 10"
                    >
                        <tr>
                            <th class="table-th py-3 px-4 text-left">
                                {{ "words.level" | translate }}
                            </th>
                            <th class="table-th py-3 px-4 text-left">
                                {{ "words.name" | translate }}
                            </th>
                            <th class="table-th py-3 px-4 text-left">
                                {{ "words.badge" | translate }}
                            </th>
                            <th class="table-th py-3 px-4 text-left">
                                {{ "words.xp-required" | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-body divide-y divide-gray-100">
                        <tr
                            *ngFor="
                                let level of levelsData.levels;
                                let i = index;
                                trackBy: trackByLevel
                            "
                            class="table-row hover:bg-gray-50"
                        >
                            <td
                                class="table-td level-number py-4 px-4 font-medium text-gray-900"
                            >
                                {{ level.number | translate }}
                            </td>
                            <td class="table-td py-4 px-4">
                                <div class="flex flex-col space-y-4">
                                    <div
                                        *ngFor="
                                            let setting of level.textSettings
                                        "
                                        class="relative w-4/5 min-w-[180px]"
                                    >
                                        <input
                                            type="text"
                                            [ngModel]="
                                                setting.value | translate
                                            "
                                            (ngModelChange)="
                                                setting.value = $event
                                            "
                                            [required]="setting.required"
                                            class="gamificacion-input"
                                        />
                                        <label
                                            *ngIf="level.title"
                                            class="gamificacion-label"
                                        >
                                            {{ level.title | translate }}
                                        </label>
                                    </div>
                                </div>
                            </td>
                            <td class="table-td py-4 px-4 overflow-visible">
                                <div class="flex flex-col space-y-4">
                                    <!-- En cualquier vista
                                    <app-badge-dropdown
                                        [badges]="[
                                            {
                                                id: 1,
                                                name: 'Badge 1',
                                                img: 'assets/badges/pack-01/1.png'
                                            }
                                        ]"
                                        [selected]="{
                                            id: 1,
                                            name: 'Badge 1',
                                            img: 'assets/badges/pack-01/1.png'
                                        }"
                                        (badgeSelected)="log($event)"
                                    ></app-badge-dropdown> -->
                                    
                                    <app-badge-dropdown
                                        [badges]="getActiveInsignias()"
                                        [selected]="level.selectedInsignia"
                                        (badgeSelected)="
                                            onBadgeSelected(i, $event)
                                        "
                                        
                                    >
                                    </app-badge-dropdown>
                                    <!-- <div
                                        *ngFor="
                                            let setting of level.selectSettings
                                        "
                                        class="relative w-4/5 min-w-[180px]"
                                    >
                                        <select
                                            [(ngModel)]="setting.selected"
                                            [required]="setting.required"
                                            class="gamificacion-select w-full py-2 pl-4 pr-8 border rounded-md border-gray-300 focus:border-primary-500 bg-white text-gray-600 font-medium appearance-none hover:border-gray-40"
                                        >
                                            <option
                                                *ngFor="
                                                    let i of [
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12, 13, 14,
                                                        15
                                                    ]
                                                "
                                                [value]="i"
                                            >
                                                {{ "words.badge" | translate }}
                                                {{ i }}
                                            </option>
                                        </select>
                                        <label
                                            *ngIf="setting.label"
                                            class="gamificacion-label absolute left-0 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none transition-all duration-300"
                                        >
                                            {{ setting.label | translate }}
                                        </label>
                                        <div
                                            class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                                        >
                                            <svg
                                                class="w-4 h-4 text-gray-500"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                    </div> -->
                                </div>
                            </td>
                            <td class="table-td py-4 px-4">
                                <div class="flex flex-col space-y-4">
                                    <div
                                        *ngFor="
                                            let setting of level.numberSettings
                                        "
                                        class="compact-control"
                                    >
                                        <input
                                            type="number"
                                            [(ngModel)]="setting.value"
                                            [placeholder]="
                                                'setting.placeholder'
                                                    | translate
                                            "
                                            [step]="setting.step || 1"
                                            [required]="setting.required"
                                            class="compact-input"
                                        />
                                        <label
                                            *ngIf="setting.label"
                                            class="gamificacion-label absolute left-0 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none transition-all duration-300"
                                        >
                                            {{ setting.label | translate }}
                                        </label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <!-- Botón de guardar -->
        <div class="actions-container flex justify-end mt-12">
            <msc-button
                class="msc-button--primary"
                palette="primary"
                (click)="saveSettings()"
                >{{ "common.save" | translate }}
            </msc-button>
        </div>
    </div>
</div>
